<div style="position: relative;">
    <div id="busy-overlay" class="component-overlay" *ngIf="isBusy">
        <div class="center">
          <mat-spinner color="accent" [diameter]="48"></mat-spinner>
        </div>
    </div>
    <div style="margin-bottom: 24px;">
        <button mat-button *ngIf="!hasOperationAndMaintenanceSection" color="accent" (click)="initializeOperationAndMaintenanceSection()">
            <mat-icon>add</mat-icon>
            SERVICE & WARTUNG  HINZUFÜGEN
        </button>
        <button mat-button *ngIf="!hasItSection" color="accent" (click)="initializeItSection()">
            <mat-icon>add</mat-icon>
            IT-SERVICES HINZUFÜGEN
        </button>
    </div>
    <div style="width: 100%; height: 100%;">
        
        <div [hidden]="!hasOperationAndMaintenanceSection" style="margin-top: 24px;">
            <mat-divider style="margin-bottom: 12px;"></mat-divider>
            <h2>Service & Wartung</h2>
            <app-entries-table #operationAndMaintenanceTable 
                               [productsDataSource]="operationAndMaintenanceServices"
                               [originalEntries]="operationAndMaintenanceSection"
                               (discardChangesCalled)="discardOperationAndMaintenanceSectionChanges()"
                               (saveChangesCalled)="saveOperationAndMaintenanceSectionChanges($event)"
                               (deleteCalled)="deleteOperationAndMaintenanceSection()"></app-entries-table>
        </div>
    
        <div [hidden]="!hasItSection" style="margin-top: 24px;">
            <mat-divider style="margin-bottom: 12px;"></mat-divider>
            <h2>IT Services</h2>
            <app-entries-table #itTable 
                               [productsDataSource]="itServices"
                               [originalEntries]="itSection"
                               (discardChangesCalled)="discardItSectionChanges()"
                               (saveChangesCalled)="saveItSectionChanges($event)"
                               (deleteCalled)="deleteItSection()"></app-entries-table>
        </div>
    
    </div>
</div>
